import { useSponsoredEnrollmentProfileBootstrap } from './useSponsoredEnrollmentProfileBootstrap'

type SponsoredEnrollmentProfileBootstrapProps = {
  sessionToken: string | null
  onError: (message: string | null) => void
  onLoadingChange: (isLoading: boolean) => void
}

export function SponsoredEnrollmentProfileBootstrap({
  sessionToken,
  onError,
  onLoadingChange
}: SponsoredEnrollmentProfileBootstrapProps) {
  useSponsoredEnrollmentProfileBootstrap({ sessionToken, onError, onLoadingChange })

  return null
}
